{
  "nav": {
    "label": "DEC Capital sections",
    "home": "Back to DEC Energy",
    "top": "DEC Capital, back to the top",
    "now": "Why now",
    "about": "What we do",
    "why": "Our story",
    "strategy": "Strategy",
    "people": "Committee",
    "contact": "Contact",
    "cta": "Request information"
  },
  "hero": {
    "eyebrow": "For professional and qualified investors",
    "title": "Acquire revenue shares in renewable plants.",
    "subtitle": "Share in the <strong>returns generated by renewable plants</strong> already in operation, through a model that ensures maximum diversification and contractual protection, <strong>without buying the assets</strong>."
  },
  "thesis": {
    "heading": "Finance in support of renewable energy",
    "actor": {
      "investor": "Investors",
      "producer": "Producers"
    },
    "benefit": {
      "investor": "<strong>Exposure to the returns</strong> of operating renewable assets, maximising deployment speed and reducing risk.",
      "producer": "<strong>Immediate capital</strong> as semi-equity, without selling their plants or taking on more debt."
    },
    "model": {
      "title": "The model",
      "text": "A contractual structure for buying <strong>recurring revenues</strong>\nfrom operating renewable plants."
    }
  },
  "investment": {
    "eyebrow": "The advantages",
    "heading": "Investing in renewables with DEC Capital is:",
    "immediate": {
      "title": "Immediate",
      "text": "<strong>Plants already producing</strong>, no waiting for construction or permits."
    },
    "diversified": {
      "title": "Diversified",
      "text": "Revenues from a <strong>diversified portfolio</strong> of plants, producers and ways of selling energy."
    },
    "lowerRisk": {
      "title": "Lower risk",
      "text": "<strong>Lower CAPEX</strong> than buying plants. Production floors and payment guarantees."
    },
    "noOwnership": {
      "title": "No ownership",
      "text": "<strong>A priority creditor position</strong> over equity, subordinated only to the senior lender."
    }
  },
  "whyDec": {
    "heading": "The link with DEC Energy",
    "lede": "The network, the model and the experience DEC Energy has built in the industrial world, put to work for investors.",
    "network": {
      "title": "The network",
      "text": "Through <strong>our network of producers</strong>, we select the plants that meet the requirements of the investment strategy."
    },
    "model": {
      "title": "The model",
      "text": "DEC Energy <strong>invented this model</strong>, already proven in industry through agreements with Italian and Swiss producers and consumers."
    },
    "experience": {
      "title": "The experience",
      "text": "The people leading DEC Capital bring <strong>100 years of combined experience</strong> in renewable energy."
    }
  },
  "whyNow": {
    "eyebrow": "A market window, a great opportunity",
    "title": "A market window,",
    "turn": "a great opportunity.",
    "incentives": "Energy producers want to build more plants to make the most of the <strong>available incentives</strong> (FER X, Energy Release 2.0, …).",
    "debt": "But the <strong>financing solutions available are limited</strong>, and selling their plants is not an option.",
    "gap": "What is missing is a model that provides <strong>immediate liquidity</strong> without adding debt or selling plants."
  },
  "interlude": {
    "eyebrow": "Opportunities at a glance",
    "heading": "Some of the plants contracted or in negotiation",
    "prev": "Previous plants",
    "next": "Next plants",
    "plants": {
      "solar": "Solar",
      "wind": "Wind"
    },
    "power": "{{mw}} MWp"
  },
  "trackRecord": {
    "eyebrow": "Track record",
    "heading": "Already in operation, not on paper.",
    "proof": "The model has been <strong>established for decades</strong> in oil & gas, mining and renewables abroad. DEC Energy brought it to European renewables, together with leading companies in energy and beyond.",
    "producers": {
      "value": "{{n}}+",
      "label": "Producers with plants in Italy"
    },
    "volume": {
      "value": "{{n}} GWh",
      "label": "Closed or in advanced negotiation on the DEC Energy model"
    },
    "fintech": {
      "value": "3rd",
      "label": "Fintech startup in Switzerland"
    },
    "energyFintech": {
      "value": "1st",
      "label": "Energy-fintech startup in Italy"
    }
  },
  "strategy": {
    "heading": "Taking part in renewables while reducing their risks",
    "portfolio": {
      "title": "Portfolio strategy",
      "route": "Mostly energy sold <strong>at fixed tariffs</strong> (FER 1, FER X, …)",
      "producers": "Mostly <strong>large producers</strong> (utilities and IPPs)",
      "technology": "Mostly <strong>solar plants</strong>, with a share of wind"
    },
    "risk": {
      "title": "Risk profile",
      "operating": "<strong>Only plants</strong> already connected and producing",
      "floor": "<strong>Production floor</strong> guaranteed by the owner",
      "seniority": "<strong>A position senior</strong> to equity",
      "payments": "<strong>Payment guarantees</strong> on the amounts due"
    }
  },
  "people": {
    "eyebrow": "Investment committee",
    "heading": "Over 100 years of experience in renewable energy",
    "roles": {
      "scarinzi": "Co-founder and CEO @DEC Energy",
      "bonu": "Co-founder and COO @DEC Energy",
      "rossi": "Former CEO of AET and AEM",
      "truglio": "Country manager Italy RP Global",
      "piccioliFaccoli": "CIO Nvalue"
    },
    "linkedin": "{{name}} on LinkedIn"
  },
  "contact": {
    "heading": "The next step",
    "body": "A meeting with management to walk through the pipeline and the contracts, and to explore how we can work together.",
    "sentTitle": "Request sent",
    "sent": "Thank you, we have received your request. We will get back to you shortly."
  },
  "form": {
    "fields": {
      "name": {
        "label": "Full name",
        "error": "Enter your full name"
      },
      "company_name": {
        "label": "Company",
        "error": "Enter your company"
      },
      "email": {
        "label": "Email",
        "error": "Enter a valid email address"
      },
      "number": {
        "label": "Phone",
        "required": "Enter your phone number",
        "invalid": "Enter a valid phone number"
      },
      "user_type": {
        "label": "Profile",
        "error": "Select a profile"
      },
      "additional_info": {
        "label": "Message (optional)"
      }
    },
    "submit": "Send request",
    "select": "Select"
  },
  "investorTypes": {
    "familyOffice": "Family office",
    "privateBank": "Private bank",
    "privateInvestor": "Private investor",
    "institutional": "Institutional investor",
    "producer": "Energy producer",
    "industrial": "Industrial investor",
    "other": "Other"
  },
  "footer": {
    "tagline": "Acquire revenue shares in renewable plants"
  }
}
